import {PropsWithChildren, useEffect, useMemo} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "@bounce/shared/contexts";
import {urls} from "~/routes/consumerUrls";

interface GuestGuardProps extends PropsWithChildren {
  unknownUser?: boolean;
}

interface LocationState {
  origin?: string;
}

const GuestGuard = ({unknownUser = false, children}: GuestGuardProps) => {
  const {loggedIn, clearCredentials} = useAuth();
  const location = useLocation();
  const token = useMemo<string>(() => localStorage.getItem("agentToken") || "", [localStorage]);
  const agentEmail = useMemo<string>(() => localStorage.getItem("agentEmail") || "", [localStorage]);
  const agentRole = useMemo<string>(() => localStorage.getItem("agentRole") || "", [localStorage]);
  useEffect(() => {
    if (token) {
      localStorage.removeItem("agentToken");
      clearCredentials();
    }
    if (agentEmail) {
      localStorage.removeItem("agentEmail");
    }
    if (agentRole) {
      localStorage.removeItem("agentRole");
    }
  }, [token, agentEmail, agentRole]);

  if (loggedIn && !unknownUser) {
    if (location.state) {
      const {origin} = location.state as LocationState;
      if (origin) {
        return <Navigate to={origin} state={location.state} />;
      }
    }
    return <Navigate to={urls.accounts.url} state={location.state} />;
  }

  return <>{children}</>;
};

export default GuestGuard;
